// @ts-nocheck
import React, {Fragment, useEffect, useState} from 'react';
import Gauge from "react-gaugejs"
import {gaugeOptions} from '@components/module-components/consumtionGaugeChart/helpers';

const styles = {
  gauge: {
    width: '98px',
    height: '70px',
  }
}

const EcoScoreGauge = ({value, donut = false}) => {

  const [gaugeValue, setGaugeValue] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => setGaugeValue(value), 100);
    return () => clearTimeout(timeout);
  }, [value]);

  const handleTextChange = (newValue) => {
    // this fired when value change from min to {value} or max
    // you can try to show loading or do stuffs here.
  };


  return <Fragment>

    <Gauge
      style={styles.gauge}
      value={gaugeValue}
      minValue={0}
      maxValue={100}
      animationSpeed={32}
      options={gaugeOptions}
      textChangeHandler={handleTextChange}
      donut={donut}
    />
  </Fragment>
};

export default EcoScoreGauge;
